export function Check(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.4734 0.122191C14.0316 0.395062 14.2833 1.04372 14.0727 1.61434L14.0244 1.72729L8.22484 13.5911C7.44868 15.1789 5.53234 15.8368 3.94459 15.0606C3.66725 14.9251 3.41136 14.7503 3.18466 14.5419L3.02023 14.3795L0.326352 11.5185C-0.127979 11.036 -0.105139 10.2766 0.377366 9.82225C0.827703 9.39821 1.5193 9.38984 1.97889 9.7829L2.07366 9.87327L4.76753 12.7342C4.83366 12.8044 4.91195 12.8621 4.99862 12.9045C5.36503 13.0836 5.80142 12.9572 6.01901 12.6245L6.06868 12.5371L11.8683 0.673257C12.1593 0.0778499 12.878 -0.168871 13.4734 0.122191Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
